import React from "react";
import MultiSelectWrapper from "../MultiSelectWrapper/MultiSelectWrapper";
import { CreateAdminFormFields } from "Shared/types/Admins";
import { usePartnerConfig } from "Hooks/usePartnerConfig";
import { useFormContext } from "react-hook-form";
import { FormField } from "Components/Shared/FormComponents/FormField/FormField";
import { Option } from "Shared/types/Option";

const PayGroupSelect = () => {
  const { setValue } = useFormContext<
    CreateAdminFormFields
  >();
  const { companies } = usePartnerConfig();

  const payGroupOptions = companies.map(company => {
    return { label: company.payGroup, value: company.id };
  });

  return (
    <FormField fieldName="Pay Group(s)">
      <MultiSelectWrapper
        onChange={(selected: Option[]) => setValue("companyIds", selected)}
        options={payGroupOptions}
        placeholder="Specify pay group access"
      />
    </FormField>
  );
};

export default PayGroupSelect;
